import { SystemStyleObject } from '@chakra-ui/react';

interface AudioPlayerControlsSxProps {
  extendedPlayer: boolean;
  isPlaylistMode: boolean;
}

interface AudioPlayerControlsSxResults {
  playerControls: SystemStyleObject;
  rewindButton: SystemStyleObject;
  skipButton: SystemStyleObject;
  timeMark: SystemStyleObject;
  durationText: SystemStyleObject;
  separator: SystemStyleObject;
  controls: SystemStyleObject;
}

export const audioPlayerControlsSx: ({
  extendedPlayer,
  isPlaylistMode,
}: AudioPlayerControlsSxProps) => AudioPlayerControlsSxResults = ({
  extendedPlayer,
  isPlaylistMode,
}) => ({
  playerControls: {
    position: 'relative',
    maxWidth: 1000,
    minWidth: { base: 'auto', lg: '300' },
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 100%',
    gridTemplateAreas: `'controls timeMark separator duration repeat'`,
    ...(extendedPlayer
      ? {
          display: 'grid',
          gridTemplateColumns: '56px 1fr 56px',
          gridTemplateAreas: `"track track track"
          "timeMark . duration"
          ". controls ."`,
          justifyContent: 'space-between',
        }
      : {}),
  },
  controls: {
    alignItems: 'center',
    ...(extendedPlayer
      ? {
          gridTemplateAreas: `'playlist rewind play ${
            isPlaylistMode ? 'skip' : ''
          } repeat'`,
          gap: 8,
          w: 'min-content',
          mt: 7,
          mb: 2,
          mx: 'auto',
        }
      : {
          display: 'flex',
        }),
  },
  rewindButton: {
    width: 4,
    height: 4,
    color: 'M.60',
    ...(extendedPlayer
      ? {}
      : {
          display: { base: 'none', lg: 'block' },
          mr: 4,
        }),
    _hover: {
      cursor: 'pointer',
      color: 'M.70',
    },
  },
  skipButton: {
    gridArea: 'skip',
    width: 4,
    height: 4,
    color: 'M.60',
    ...(extendedPlayer
      ? {}
      : {
          display: { base: 'none', lg: 'block' },
          ml: 4,
        }),
    _hover: {
      cursor: 'pointer',
      color: 'M.70',
    },
  },
  timeMark: {
    gridArea: 'timeMark',
    color: 'textBase',
    my: 0,
    mr: 1,
    whiteSpace: 'nowrap',
    ...(extendedPlayer
      ? {
          justifySelf: 'flex-start',
        }
      : { minWidth: '60px' }),
    maxWidth: '60px',
    textAlign: 'right',
  },
  durationText: {
    gridArea: 'duration',
    color: 'textBase',
    ml: 1,
    ...(extendedPlayer
      ? {
          justifySelf: 'flex-end',
        }
      : { minWidth: '60px' }),
    maxWidth: '60px',
    whiteSpace: 'nowrap',
  },
  separator: {
    gridArea: 'separator',
    display: { base: 'block', md: 'none' },
    color: 'textSubdued',
  },
});
